import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faCircleArrowUp } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCircleArrowUp as faCircleArrowUpSolid } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { CurrentUserPostVoteStatus } from '@graphql/reactQuery';

export function UpvoteButton({
  className,
  disabled,
  onClick,
  upvoteCount,
  variant,
  voteStatus,
}: {
  className?: string;
  disabled: boolean;
  onClick: () => void;
  upvoteCount: number;
  variant: 'post' | 'comment';
  voteStatus: CurrentUserPostVoteStatus | undefined;
}) {
  const isUpvoted = voteStatus === CurrentUserPostVoteStatus.Upvoted;

  const textColor = isUpvoted ? 'text-fuchsia500' : 'text-neutral500';

  const icon = isUpvoted ? faCircleArrowUpSolid : faCircleArrowUp;

  const iconSize = variant === 'post' ? 18 : 14;

  return (
    <button
      className={twMerge(
        'flex items-center gap-1 rounded-md px-2 py-1 hover:bg-neutral100 active:scale-95',
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={icon} className={textColor} fontSize={iconSize} />
      <span className={twMerge('font-base !text-base-m font-medium', textColor)}>
        {upvoteCount}
      </span>
    </button>
  );
}
